import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class TableLimitService {
  private static readonly STORAGE_KEY = 'table_limit';
  private static readonly DEFAULT_LIMIT = 25;

  getLimit(): number {
    try {
      const stored = localStorage.getItem(TableLimitService.STORAGE_KEY);

      if (stored !== null) {
        const parsed = parseInt(stored, 10);

        if (!isNaN(parsed) && parsed > 0) {
          return parsed;
        }
      }
    } catch {
      // localStorage unavailable
    }

    return TableLimitService.DEFAULT_LIMIT;
  }

  saveLimit(limit: number): void {
    try {
      localStorage.setItem(TableLimitService.STORAGE_KEY, String(limit));
    } catch {
      // localStorage unavailable
    }
  }
}
